import {COMPANY_MATCH_IN_PIPELINE_STATUS_IDS} from '../companyMatchesListFilters';

import {MatchTotalCountPerStatus} from '../../../../../types/shared-recruiting-types';

export function inPipelineMatchCount(counts: MatchTotalCountPerStatus): number {
  return COMPANY_MATCH_IN_PIPELINE_STATUS_IDS.reduce((sum, id) => {
    if (id === 'on_hold') {
      return sum + (counts.onHold ?? 0);
    }
    if (id === 'contacted') {
      return sum + counts.contacted;
    }
    return sum + counts.interview;
  }, 0);
}
